import { render, staticRenderFns } from "./squareButton.vue?vue&type=template&id=ff196d0a"
import script from "./squareButton.vue?vue&type=script&lang=js"
export * from "./squareButton.vue?vue&type=script&lang=js"
import style0 from "./squareButton.vue?vue&type=style&index=0&id=ff196d0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports